export const formatTopicsFromClusters = clusters => {
    if (!Array.isArray(clusters)) {
        return []
    }

    return clusters.map(cluster => {
        const fallbackName =
            cluster.nodes
                ?.slice(0, 3)
                .map(node => node.nodeName)
                .join(' ') || `Topic ${cluster.community}`

        return {
            id: parseInt(cluster.community),
            aiName: cluster.aiName || fallbackName,
            ...cluster,
        }
    })
}

const buildAiNameMap = topicsExtension => {
    if (!topicsExtension?.topClusters) {
        return new Map()
    }

    return new Map(
        topicsExtension.topClusters
            .filter(entry => entry && entry.aiName)
            .map(entry => [String(entry.community), entry.aiName])
    )
}

export const applyTopicsExtensionToGraph = (graphData, topicsExtension) => {
    if (!graphData || !topicsExtension) {
        return graphData
    }

    const graphologyGraph =
        graphData?.entriesAndGraphOfContext?.graph?.graphologyGraph
    const graphAttributes = graphologyGraph?.attributes

    if (!graphAttributes?.top_clusters) {
        return graphData
    }

    const aiNameByCommunity = buildAiNameMap(topicsExtension)
    if (aiNameByCommunity.size === 0) {
        return graphData
    }

    const updatedTopClusters = graphAttributes.top_clusters.map(cluster => {
        const aiName = aiNameByCommunity.get(String(cluster.community))
        return aiName ? { ...cluster, aiName } : cluster
    })

    const updatedGaps = Array.isArray(graphAttributes.gaps)
        ? graphAttributes.gaps.map(gap => {
              const fromAiName = aiNameByCommunity.get(
                  String(gap.from.community)
              )
              const toAiName = aiNameByCommunity.get(String(gap.to.community))

              if (!fromAiName && !toAiName) {
                  return gap
              }

              return {
                  ...gap,
                  from: {
                      ...gap.from,
                      ...(fromAiName ? { aiName: fromAiName } : {}),
                  },
                  to: {
                      ...gap.to,
                      ...(toAiName ? { aiName: toAiName } : {}),
                  },
              }
          })
        : graphAttributes.gaps

    return {
        ...graphData,
        entriesAndGraphOfContext: {
            ...graphData.entriesAndGraphOfContext,
            graph: {
                ...graphData.entriesAndGraphOfContext.graph,
                graphologyGraph: {
                    ...graphologyGraph,
                    attributes: {
                        ...graphAttributes,
                        top_clusters: updatedTopClusters,
                        gaps: updatedGaps,
                    },
                },
            },
        },
    }
}
